import React from "react";
import Logo from "./Logo";
import RecursiveMenu from "./RecursiveMenu";
import Storage from "@/app/core/util/Storage";

export default function Nav(props) {
  const userData = Storage.getUserData();

  return (
    <nav id="sidebar" aria-label="Main Navigation">
      <div className="bg-header-white">
        <div className="content-header bg-white-10 m-0">
          {/* <Logo /> */}
              <div className="mr-0 pr-0">
                  <img class="img-avatar mr-0" src="assets/media/avatars/avatar7.jpg"/>
              </div>
              <br/>
              <div className="ml-0 pl-0">
                  <p class="font-size-sm font-italic text-muted mb-0">
                      Olá
                  </p>
                  <p class="font-w600 mb-0">{userData && `${userData.firstName} ${userData.lastName}`}</p>
              </div>
          <div>
            <a
              className="d-lg-none text-warning ml-2"
              href="javascript:void(0)"
              onClick={() => props.toggleNav()}
            >
              <i className="fa fa-2x fa-times-circle" />
            </a>
          </div>
        </div>
      </div>
      <div className="content-side content-side-full">
        <ul className="nav-main">
          <RecursiveMenu data={props.menu} />
        </ul>
        <hr className="text-muted"/>
        <ul className="nav-main">
          <RecursiveMenu data={props.settings} />
        </ul>
      </div>
    </nav>
  );
}
